import React from 'react'

const LiveAgentsIcon = props => (
  <svg width="32" height="34" viewBox="0 0 32 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#000" fill="none" strokeWidth="1.5">
      <circle cx="16" cy="12" r="4" />
      <path d="M8 27c0-4 3.5-7 8-7s8 3 8 7" />
    </g>
  </svg>
)

export default LiveAgentsIcon

